import Container from '../../common/Container';
import Header from '../../common/Header';
import ScrollToTop from '../../common/ScrollToTop';
import ContentBlock from '../../components/landing/ContentBlock';
import MiddleBlock from '../../components/landing/MiddleBlock';
// import ContactContent from "../../content/ContactContent.json";
// import TeamBlock from '../../components/landing/TeamBlock';
import AboutContent from '../../content/AboutContent.json';
import IntroContent from '../../content/IntroContent.json';
import MiddleBlockContent from '../../content/MiddleBlockContent.json';
// import MissionContent from '../../content/MissionContent.json';
import ProductContent from '../../content/ProductContent.json';

// const Contact = lazy(() => import("../../components/ContactForm"));
// const MiddleBlock = lazy(() => import('../../components/landing/MiddleBlock'));
// const Container = lazy(() => import('../../common/Container'));
// const ScrollToTop = lazy(() => import('../../common/ScrollToTop'));
// const ContentBlock = lazy(
//   () => import('../../components/landing/ContentBlock')
// );

const Home = () => {
  return (
    <Container>
      <Header />
      <ScrollToTop />
      <ContentBlock
        type='right'
        title={IntroContent.title}
        content={IntroContent.text}
        button={IntroContent.button}
        icon='high_res_logo.png'
        id='intro'
      />
      <MiddleBlock
        title={MiddleBlockContent.title}
        content={MiddleBlockContent.text}
        button={MiddleBlockContent.button}
      />
      <ContentBlock
        type='left'
        title={AboutContent.title}
        content={AboutContent.text}
        section={AboutContent.section}
        icon='staking.png'
        id='about'
      />
      <ContentBlock
        type='left'
        title={ProductContent.title}
        content={ProductContent.text}
        icon='high_res_logo.png'
        id='product'
      />
    </Container>
  );
};

export default Home;
